import { Component } from '@angular/core';

import { ee } from '../../constants';
import { Alert } from '../../models/alert.model';

@Component({
  selector: 'app-search-query-info-modal',
  templateUrl: './search-query-info-modal.component.html',
  standalone: false
})
export class SearchQueryInfoModalComponent {

  examples = [
    'cannabis canapa',
    '"recovery fund"',
    'tobacco beer -wine',
    '"louis vuitton" prada armani "fashion week"',
    '"united states" american*',
    'vaccine AND (pfizer moderna)',
    '("start-up" startup) AND (incentiv* agevolaz* "fondo perduto")',
    '"energy costs"~5'
  ];

  runAlertQuery(keyword: string): void {
    const alert: Alert = {
      query: {
        keyword, person: '', noperson: '',
        source: '', commission: '', lang: '',
        country: '', organ: ''
      }
    };
    ee.emit('runAlertQuery', alert);
  }
}
